import z from 'zod';

import { VALIDATION_TYPE } from 'src/features/validationTypes/utils/types';
import { validationMessagesMap } from 'src/utils/messages';
import { CURRENCY } from 'src/types';

export type ValidationTypeFormSchemaValues = z.infer<typeof validationTypeFormSchema>;
export const validationTypeFormSchema = z
    .object({
        name: z.string().max(64).nonempty(),
        validator_account: z.string().nonempty(),
        type: z.enum(VALIDATION_TYPE),
        amount: z.int().min(0).optional(),
        currency: z.enum(CURRENCY).optional(),
        is_active: z.boolean().optional(),
        can_be_stacked: z.boolean().optional(),
        can_be_combined: z.boolean().optional(),
    })
    .superRefine((data, ctx) => {
        if (data.type !== VALIDATION_TYPE.GUEST && !data.amount) {
            ctx.addIssue({
                path: ['amount'],
                message: validationMessagesMap.validationErrorRequired,
                code: 'custom',
            });
        }
        if (data.type === VALIDATION_TYPE.CHARGE && !data.currency) {
            ctx.addIssue({
                path: ['currency'],
                message: validationMessagesMap.validationErrorRequired,
                code: 'custom',
            });
        }
    });
